import { RootState } from '@/state/store';

const postInquiries = (state: RootState) => state.inquiry.inquiries.entities;

const postInquiriesStatus = (state: RootState) => state.inquiry.inquiries.fetchStatus;

const updateInquiries = (state: RootState) => state.inquiry.updateInquiries.fetchStatus;

export default {
  postInquiries,
  postInquiriesStatus,
  updateInquiries,
};
